import {combineReducers} from 'redux';
import * as Constant from './constants'

const loading = (state = false, action) => {
    switch (action.type) {
        case Constant.DELETE_INVOICE_CODE_FROM_TRANSACTION.SUCCESS:
        case Constant.DELETE_INVOICE_CODE_FROM_TRANSACTION.FAILED:
        case Constant.CLEAR_MODAL_INVOICE_CODE_2_TRANSACTION:
            return false;
        case Constant.DELETE_INVOICE_CODE_FROM_TRANSACTION.REQUEST:
            return true;
        default:
            return state;
    }
};

export default combineReducers({
    loading,
});